export const RESPONSIBLE_PEOPLE = [
  "Nora",
  "Barry",
  "Ben",
  "Jacob",
  "Marcus",
  "Household",
];

export const UNASSIGNED_PERSON = "Unassigned";

export const PERSON_COLORS = {
  Nora: "#db2777",
  Barry: "#2563eb",
  Ben: "#059669",
  Jacob: "#d97706",
  Marcus: "#7c3aed",
  Household: "#475569",
  Unassigned: "#9ca3af",
};

export function normalizePerson(value) {
  if (value == null) return null;
  const text = String(value).trim();
  if (!text) return null;
  return (
    RESPONSIBLE_PEOPLE.find(
      (person) => person.toLowerCase() === text.toLowerCase(),
    ) || null
  );
}

export function personLabel(value) {
  return normalizePerson(value) || UNASSIGNED_PERSON;
}
